var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"uploadPic js-uploadPicBtn",attrs:{"tag":"div","to":"/Rccl.Review/ReviewPicture/UploadPicture"}},[_c('div',{staticClass:"uploadPic-container"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/cameraIcon.png")}})]),_c('p',[_vm._v("上传美照")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }